import React from 'react';
import {useTranslation} from "react-i18next";
import EmptyState from "../../../feeback/State/Empty";
import Graphic from "../../../../../resources/images/album-links.svg";

const Empty = () => {
    const {t} = useTranslation();
    return (
        <EmptyState
            title={t('album_links_empty_title')}
            textI18Key='album_links_empty_text'
            graphic={Graphic}
        />
    );
};

export default Empty;